const u = navigator.userAgent
export const device = (() => {
  let platform = {
    /* IE内核 */
    trident: u.includes('Trident'),
    /* opera内核 */
    presto: u.includes('Presto'),
    // 苹果、谷歌内核
    webKit: u.includes('AppleWebKit'),
    // 火狐内核
    gecko: u.includes('Gecko') && !u.includes('KHTML'),
    // 是否为移动终端
    mobile: /AppleWebKit.*Mobile.*/.test(u),
    // ios终端
    ios: /\(i[^;]+;( U;)? CPU.+Mac OS X/.test(u),
    // android终端或者uc浏览器
    android: /Android|Linux/.test(u),
    // 是否为iPhone或者QQHD浏览器
    iPhone: /iPhone|Mac/.test(u),
    // 是否iPad
    iPad: u.includes('iPad'),
    // 是否web应该程序，没有头部与底部
    webApp: !u.includes('Safari'),
    // 是否在微信内
    weixin: u.includes('MicroMessenger'),
    // 是否在app内
    umoocApp: u.includes('umoocApp')
  }
  return {
    platform,
    isMobile: platform.mobile,
    isRunningStandalone: platform.umoocApp
  }
})()
